import React from "react";
import { useSelector } from "react-redux";
import ArticleCard from "./ArticleCard";
import { Link } from "react-router-dom";
import { formatDate } from "../../utils/helps";
export default function SocialResponsibility() {
  const posts = useSelector((state) =>
    state.posts?.posts
      ?.filter(
        (post) =>
          post.status === "published" &&
          post.slug !== "gioi-thieu" &&
          post.slug !== "dieu-khoan" &&
          post.category?.name === "Trách nhiệm xã hội"
      )
      ?.filter((e) => e.type !== "notification")
      ?.slice(0, 7)
  );
  return (
    <div className="container mx-auto pt-2">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        {posts?.[0] && (
          <div className="lg:col-span-5">
            <div className="card bg-base-100 shadow-xl mb-2">
              <figure className="relative aspect-square">
                <img
                  src={`${process.env.REACT_APP_API_URL}media/${posts?.[0]?.images[0]?.url}`}
                  alt={posts?.[0]?.title}
                  className="w-full h-full object-cover"
                />
              </figure>
              <div className="card-body">
                <Link to={`/post/${posts?.[0]?.slug}`}>
                  <h3
                    className="card-title text-sm overflow-hidden text-ellipsis text-justify"
                    style={{
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 3,
                    }}
                  >
                    {posts?.[0]?.title}
                  </h3>
                </Link>

                <p className="text-xs text-gray-500 italic">
                  {formatDate(posts?.[0]?.updatedAt)}
                </p>
              </div>
            </div>
          </div>
        )}
        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {posts?.slice(1).map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
